/**
 * Created by renatolovizotto on 12/07/17.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../assets/stylesheets/Dropdown.scss';

export default class Dropdown extends Component {

    static propTypes = {
        opened: PropTypes.bool,
        selectedItem: PropTypes.string,
        items: PropTypes.any,
        nullOption: PropTypes.string,
        onChange: PropTypes.func,
    };

    static defaultProps = {
        opened: false,
        selectedItem: null,
        onChange: () => {},
        nullOption: 'Select Option'
    };

    constructor(props) {
        super(props);
        this.state = {
            opened: props.opened,
            selectedItem: props.selectedItem != null ? props.selectedItem : props.nullOption,
            items: [],
            type: props.nullOption.split(' ').pop().trim()
        }
    }

    componentDidMount() {
        // TODO: check if element is Mounted
        document.addEventListener('click', (e) => { this._closeDropdown(e) }, false);

        const items = this.props.items;
        this.setState({
            items: items.length > 0
                ? [{id: -1, name: this.props.nullOption}, ...items]
                : [{id: -1, name: this.props.nullOption}]
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', (e) => { this._closeDropdown(e) }, false);
    }

    _closeDropdown(e) {
        if (e.target !== this.dropdown
            && document.querySelectorAll('.dropdown-items').length > 0) {
            this.setState({opened: false});
        }
    }

    componentWillReceiveProps(props) {
        this.setState({
            items: props.items.length > 0
                ? [{id: -1, name: props.nullOption}, ...props.items]
                : [{id: -1, name: props.nullOption}]
        });

        if (props.items.length === 0 || props.items !== this.props.items) {
            this.setState({
                selectedItem: this.props.nullOption
            })
        }
    }

    handleClick(item) {
        if(this.state.type == "Lesson" && item.day != undefined ){
            //var year = item.day.substr(0, item.day.indexOf('-'));
            var selectedItem = "("+ item.day + ") " + item.activity;

            this.setState((prevState, props) => {
                return {
                opened: !prevState.opened,
                selectedItem: item ? (selectedItem) : this.props.nullOption
            }});
        }else{
            this.setState((prevState, props) => {
                return {
                opened: !prevState.opened,
                selectedItem: item ? (item.name || item.activity) : this.props.nullOption
            }});
        }

        this.props.onChange(item);
    }

    handleOpen() {
        this.setState(prevState => ({opened: !prevState.opened}));
    }

    render() {
        const itemsEl = this.state.items.map(
            (item, index) => {
                if(this.state.type == 'Lesson' && item.day != undefined){
                    //var year = item.day.substr(0, item.day.indexOf('-'));
                    return <li key={index} onClick={this.handleClick.bind(this, item)}>({item.day}) {item.name || item.activity}</li>
                }
                else{
                    return <li key={index} onClick={this.handleClick.bind(this, item)}>{item.name || item.activity}</li>
                }
            }
        );

        return (
            <div className="Dropdown">
                <div className="dropdown-selected" ref={ref => this.dropdown = ref}
                     onClick={this.handleOpen.bind(this)}>{this.state.selectedItem}</div>
                <div className={"dropdown-items" + (this.state.opened ? " opened" : "")}>
                    <ul>
                        <li key={-1} onClick={this.handleClick.bind(this, -1)}>{this.state.nullOption}</li>
                        {itemsEl}
                    </ul>
                </div>
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/Dropdown.js